//
//
//
//
//

  export default {
    name: "",
    props: [""],
    data() {
      return {
        code: "",
        apiUrl: "",
        loading: true,
        myUrl: ""
      };
    },

    components: {},
    activated() {},
    created() {},

    beforeMount() {},

    mounted() {
      this.$vux.loading.show({
        text: "Loading"
      });
      this.code = this.getUrlCode("code");
      this.$http.get("./static/api/api.json").then(response => {
        this.apiUrl = response.api;
        this.getToken();
      });
    },
    methods: {
      getToken() {
        if (this.code) {
          this.$http
            .post(this.apiUrl + "/web/login", {
              code: this.code
            })
            .then(res => {
              if (res.code === 0) {
                this.$vux.loading.hide()
                localStorage.setItem("users_token", res.data.token);
                window.location.href = window.location.protocol + "//" + window.location.host + "/home";
              }
            });
        }else {
          console.error('非法访问')
        }
      },
      // 截取code
      getUrlCode(name) {
        return (
          decodeURIComponent(
            (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
              location.href
            ) || [, ""])[1].replace(/\+/g, "%20")
          ) || null
        );
      }
    },
    watch: {}
  };




// WEBPACK FOOTER //
// ./src/components/login.vue